<template>
	<div class="treevia-academy">
		<div
			class="treevia-academy-container"
			v-if="showVideo === false"
		>
			<div class="search-bar-container">
				<button
					class="btn-go-back"
					v-if="query"
					@click="cleanSearch"
				>
					<img src="@/assets/go-back-icon.png" />
					{{ $t('goBackToModules') }}
				</button>
				<InputSearch
					v-model="query"
					:placeholder="$t('search')"
					class="search-bar-treeviaacademy"
				>
				</InputSearch>
			</div>
			<div
				class="txt-search-results-container"
				v-if="query"
			>
				<div
					v-if="searchResults.length === 0"
					class="no-search-results"
				>
					<img src="@/assets/search-icon.png" />
					<span class="txt-search-result">{{ $t('noResults') }} "{{ query }}"</span>
					<span class="txt-search-result">{{
						$t('tentepesquisaroutrostermosparaobtermelhoresresultados')
					}}</span>
					<span
						@click="cleanSearch"
						class="clear-search-link"
						>{{ $t('clearSearch') }}</span
					>
				</div>
				<div
					class="yes-search-results"
					v-else
				>
					<span class="txt-search-result">{{ $t('resultsFor') }} "{{ query }}"</span>
					<div class="module-itens">
						<div
							v-for="(item, index) in searchResults"
							:key="index"
							class="module-item-card"
						>
							<img
								:src="item.blob_link"
								class="capas-videos"
							/>
							<div class="module-item-card-content">
								<h3 class="txt-title-class">
									{{
										$t('tituloAula', {
											nameAula: item.titulo_aula,
											numberAula: item.cod_aula,
											numberModulo: item.modulo.cod_modulo,
										})
									}}
								</h3>
								<p>{{ item.descricao }}</p>
							</div>
							<button
								v-if="item.url_mat_apoio"
								class="btn-material-apoio"
								@click="openLink(item.url_mat_apoio)"
							>
								<img
									src="@/assets/download-icon.png"
									alt="download"
								/>
								{{ $t('supportMaterial') }}
							</button>
							<button
								class="btn-module-item-card"
								@click="
									showVideoClass(
										item.url_video,
										`Módulo ${item.modulo.cod_modulo}.${item.cod_aula} - ${item.titulo_aula}`,
										item.url_mat_apoio,
									)
								"
							>
								{{ $t('watch') }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<Accordion
					v-for="(module, index) in modulos"
					:key="index"
					:label="module.label"
					class="accordion-treeviaacademy"
				>
					<div class="module-itens">
						<div
							v-for="(item, itemIndex) in module.items"
							:key="itemIndex"
							class="module-item-card"
						>
							<img
								:src="item.blob_link"
								class="capas-videos"
							/>
							<div class="module-item-card-content">
								<h3 class="titulos-aulas">{{ item.titulo_aula }}</h3>
								<p>{{ item.descricao }}</p>
							</div>
							<button
								v-if="item.url_mat_apoio"
								class="btn-material-apoio"
								@click="openLink(item.url_mat_apoio)"
							>
								<img
									src="@/assets/download-icon.png"
									alt="download"
								/>
								{{ $t('supportMaterial') }}
							</button>
							<button
								@click="showVideoClass(item.url_video, item.titulo_aula, item.url_mat_apoio)"
								class="btn-module-item-card"
							>
								{{ $t('watch') }}
							</button>
						</div>
						<div
							class="questionary-container"
							v-if="module.url_questionary"
						>
							<img
								:src="imgQuestionary"
								class="capas-videos"
							/>
							<div class="module-item-card-content">
								<h3 class="titulos-aulas">
									{{ $t('questionariomodulo', { labelModulo: module.label }) }}
								</h3>
							</div>
							<button
								class="btn-module-item-card"
								@click="openLink(module.url_questionary)"
							>
								{{ $t('responderquestionario') }}
							</button>
						</div>
					</div>
				</Accordion>
			</div>
			<div class="btn-certificado-container">
				<button
					class="solicitar-certificado-btn"
					v-if="!query"
					@click="toggleShowCertificado"
				>
					{{ $t('requestCertificate') }}
				</button>
				<div v-if="showCertificado">
					<SolicitaCertificado
						@close="toggleShowCertificado"
						@solicitar="solicitarCertificadoPorEmail"
					/>
				</div>
			</div>
		</div>
		<VideoPlayer
			v-if="showVideo"
			:videoSrc="currentVideo"
			:title="currentVideoTitle"
			:urlMatApoio="currentVideoUrlMatApoio"
			@close="showVideo = false"
		>
		</VideoPlayer>
	</div>
</template>

<script>
import Accordion from '../../../components/Accordion/Accordion.vue'
import InputSearch from '../../../components/InputSearch/InputSearch.vue'
import SolicitaCertificado from '../../../components/SolicitaCertificado/SolicitaCertificado.vue'
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer.vue'

import { getSearchClasses, getAllclasses } from '../../../services/requests/TreeviaAcademyRequests'
export default {
	components: { Accordion, InputSearch, VideoPlayer, SolicitaCertificado },
	methods: {
		showVideoClass(currentVideo, currentVideoTitle, currentVideoUrlMatApoio) {
			this.currentVideo = currentVideo
			this.currentVideoTitle = currentVideoTitle
			this.currentVideoUrlMatApoio = currentVideoUrlMatApoio
			this.showVideo = true
		},
		cleanSearch() {
			this.query = ''
		},
		toggleShowCertificado() {
			this.showCertificado = !this.showCertificado
		},

		solicitarCertificadoPorEmail() {
			const destinatario = 'suporte@treevia.com.br'

			//  Acessa os dados corretos do localStorage
			let nomeUsuario = '[SEU NOME COMPLETO AQUI]'
			let emailUsuario = ''

			try {
				// Pega o username do localStorage 
				const username = localStorage.getItem('username')
				if (username) {
					nomeUsuario = username
				}

				// Pega o email do localStorage 
				const email = localStorage.getItem('email')
				if (email) {
					emailUsuario = email
				}
			} catch (error) {
				console.log('Erro ao acessar localStorage:', error)
			}

			const assunto = 'Solicitação de Certificado - Treevia Academy'

			const corpo = `Olá,

            Gostaria de solicitar meu certificado de conclusão do Treevia Academy.

            Dados do solicitante:
            - Nome: ${nomeUsuario}
            - Email: ${emailUsuario}

            Atenciosamente,
            ${nomeUsuario}`

			// Codifica os componentes para garantir que caracteres especiais funcionem na URL
			const urlMailto = `mailto:${destinatario}?subject=${encodeURIComponent(assunto)}&body=${encodeURIComponent(corpo)}`

			// Abre o cliente de e-mail
			window.location.href = urlMailto
			this.showCertificado = false // Fecha o modal após solicitar o certificado
		},

		openLink(url) {
			window.open(url, '_blank')
		},

		async fetchAllModulesAndClasses() {
			try {
				const response = await getAllclasses()
				const data = response.data
				const modulosMap = new Map()
				var index = 1
				data.forEach((itemApi) => {
					const moduloId = itemApi.modulo.id
					const moduloLabel = this.$t('modulo', {
						number: index,
						name: itemApi.modulo.descricao,
					})

					if (!modulosMap.has(moduloId)) {
						modulosMap.set(moduloId, {
							label: moduloLabel,
							url_questionary: itemApi.modulo.url_string_questionario,
							items: [],
						})
						index++
					}

					modulosMap.get(moduloId).items.push({
						id: itemApi.id,
						url_video: itemApi.url_video,
						blob_link: itemApi.blob_link,
						titulo_aula: this.$t('tituloAula', {
							nameAula: itemApi.titulo_aula,
							numberAula: itemApi.cod_aula,
							numberModulo: itemApi.modulo.cod_modulo,
						}),
						descricao: itemApi.descricao,
						cod_aula: itemApi.cod_aula,
						url_mat_apoio: itemApi.url_mat_apoio,
					})
					this.modulos = Array.from(modulosMap.values())
				})
			} catch (error) {
				console.error('Error fetching classes:', error)
			}
		},

		async classSearch() {
			try {
				const response = await getSearchClasses(this.query)
				this.searchResults = response.data.map((itemApi) => {
					return {
						id: itemApi.id,
						url_video: itemApi.url_video,
						blob_link: itemApi.blob_link,
						fk_modulo: itemApi.fk_modulo,
						titulo_aula: itemApi.titulo_aula,
						descricao: itemApi.descricao,
						cod_aula: itemApi.cod_aula,
						url_mat_apoio: itemApi.url_mat_apoio,
						modulo: {
							id: itemApi.modulo.id,
							cod_modulo: itemApi.modulo.cod_modulo,
							descricao: itemApi.modulo.descricao,
							status: itemApi.modulo.status,
							url_mat_apoio: itemApi.modulo.url_mat_apoio,
						},
					}
				})
			} catch (error) {
				console.error('Error fetching classes:', error)
				this.searchResults = []
			}
		},
	},

	created() {
		// Fetch all modules and classes when the component is created
		this.fetchAllModulesAndClasses()
	},
	watch: {
		query(newQuery) {
			clearTimeout(this.debounceTimer)
			if (newQuery) {
				//se tem algo na barra de pesquisa
				this.debounceTimer = setTimeout(() => {
					this.classSearch()
				}, 500)
			} else {
				//se não tem nada na barra de pesquisa
				this.searchResults = []
			}
		},
	},
	data() {
		return {
			query: '',
			searchResults: [],
			debounceTimer: null,
			showVideo: false,
			showCertificado: false,
			imgQuestionary: `${process.env.VUE_APP_AZURE_STORAGE_URL}/treeviaacademy/img/questionario.png`,
			currentVideo: '',
			currentVideoTitle: '',
			currentVideoUrlMatApoio: '',
			model: {
				id: '',
				url_video: '',
				blob_link: '',
				fk_modulo: '',
				titulo_aula: '',
				descricao: '',
				cod_aula: '',
				url_mat_apoio: '',
				modulo: {
					id: '',
					cod_modulo: '',
					descricao: '',
					status: false,
					url_mat_apoio: '',
				},
			},
			modulos: [],
		}
	},

	name: 'TreeviaAcademy',
}
</script>

<style scoped>
:root {
	--spacing-s: 8px;
	--spacing-xs: 4px;
	--spacing-default: 16px;
	--border-xs: 4px;
	--spacing-xxl: 40px;
}
.treevia-academy-container {
	display: flex;
	padding: 32px 80px;
	flex-direction: column;
	gap: 16px;
	border-radius: 8px;
	border: 1px solid var(--Grays-Medium-Gray, #737576);
}


.btn-certificado-container {
    display: flex;
    justify-content: flex-end; 
    width: 100%; 
}


.txt-title-class {
	color: var(--grays-gray-dark, #464947);

	/* text-l-bold */
	font-family: 'Open Sans';
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 111.111% */
	letter-spacing: -0.5px;
}
.btn-material-apoio {
	display: flex;
	padding: var(--spacing-xs, 4px) var(--spacing-s, 8px);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 8px);
	border-radius: var(--border-xs, 4px);
	border: 1px solid var(--secondary-secondary, #01395e);
	background: var(--neutrals-neutral-white, #fefefe);
}
.txt-search-results-container {
	display: flex;
	justify-content: flex-start;
	align-self: flex-start;
	flex-direction: column;
	gap: 16px;
	width: 100%;
}

.txt-search-result {
	color: var(--neutrals-neutral-black, #272728);

	/* text-default */
	font-family: 'Open Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem; /* 125% */
}
.btn-go-back {
	display: flex;
	padding: var(--spacing-xs, 0.25rem) var(--spacing-s, 0.5rem);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 0.5rem);
	color: var(--secondary-secondary, #01395e);
	text-align: center;

	/* text-button */
	font-family: 'Open Sans';
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.5rem; /* 171.429% */
	letter-spacing: -0.03125rem;
	text-transform: lowercase;
	flex-wrap: nowrap !important;

	white-space: nowrap !important;
}

.search-bar-container {
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	align-self: stretch;
}

::v-deep(.ui.input .form-input) {
	display: flex;
	width: 15rem;
	height: 2rem;
	padding: var(--spacing-s, 0.5rem) var(--spacing-default, 1rem) !important;
	justify-content: space-between;
	align-items: center;
	border-radius: 16px !important;
	border: 1px solid var(--grays-gray-medium, #737576);
	background: var(--Neutral-Colors-Neutral-White, #fefefe);
	color: var(--grays-gray-medium, #737576);

	/* text-s */
	font-family: 'Open Sans';
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1rem;
	/* 114.286% */
}

::v-deep(.ui.input) {
	display: flex;
	align-items: flex-end;
}

::v-deep(.ui.input .icon) {
	color: var(--secondary-secondary, #01395e);
	/* Cor do ícone azul */
	font-size: 16px;
	/* Tamanho do ícone */
	margin-left: 8px;
	/* Espaçamento entre o texto e o ícone */
	display: flex;
	height: 16px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
}

.accordion-treeviaacademy {
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: transparent !important;
	gap: var(--spacing-default, 16px);
	align-self: stretch;
	border-radius: 0px !important;
}

::v-deep(.container__accordion__label) {
	width: 100% !important;
	background-color: transparent;
	color: var(--grays-gray-dark, #464947);
	/* text-l-bold */
	font-family: 'Open Sans';
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px;
	/* 111.111% */
	letter-spacing: -0.5px;
}

::v-deep(.container__accordion) {
	border-bottom: 1px solid var(--secondary-secondary-tint-2, #67889e);
	border-radius: 0px !important;
	padding-bottom: 8px;
}

.solicitar-certificado-btn {
	display: flex;
	padding: var(--spacing-xs, 4px) var(--spacing-s, 8px);
	justify-content: flex-end;
	align-items: flex-end !important;
	gap: var(--spacing-s, 8px);
	border-radius: var(--border-xs, 4px);
	border: 1px solid var(--neutrals-neutral-black, #272728);
	background: var(--primary-primary, #95bb49);

	text-align: center;
	font-family: 'Open Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;
	/* 171.429% */
	letter-spacing: -0.5px;
	text-transform: lowercase;
}

.solicitar-btn-container {
	display: flex;
	justify-content: flex-end !important;
	align-items: flex-end !important;
	align-self: stretch;
	margin-top: auto;
}

.module-item-card {
	flex-direction: row;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
	align-self: stretch;
	min-width: 1036.8px;
	min-height: 113.3px;
}

.module-item-card-content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 0.5rem;
	flex: 1 0 0;
}

.module-itens {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-default, 1rem);
	align-self: stretch;
}

.btn-module-item-card {
	display: flex;
	padding: var(--spacing-xs, 0.25rem) var(--spacing-s, 0.5rem);
	justify-content: center;
	align-items: flex-start;
	gap: var(--spacing-s, 0.5rem);
	border-radius: var(--border-xs, 0.25rem);
	border: 1px solid var(--neutrals-neutral-black, #272728);
	background: var(--primary-primary, #95bb49);
}
.no-search-results {
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	padding: 0px 0px 0px 0px;
	align-self: center !important;
	justify-content: center !important;
	text-align: center;
}
.yes-search-results {
	gap: 16px;
	display: flex;
	flex-direction: column;
}

.clear-search-link {
	color: var(--semantic-link-link-on, #67889e);

	/* text-default-underline */
	font-family: 'Open Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px; /* 125% */
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-skip-ink: none;
	text-decoration-thickness: auto;
	text-underline-offset: auto;
	text-underline-position: from-font;
	cursor: pointer;
}
.questionary-container {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	align-self: stretch;
}
.capas-videos {
	width: 240px !important;
	height: 135px !important;
	flex-shrink: 0;
	object-fit: cover;
	display: block;
}
.titulos-aulas {
	color: var(--grays-gray-dark, #464947);

	/* text-l-bold */
	font-family: 'Open Sans';
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 111.111% */
	letter-spacing: -0.5px;
}
</style>
